module.exports = "../fonts/icomoon.woff";


//////////////////
// WEBPACK FOOTER
// ./@fonts/icomoon/icomoon.woff
// module id = 518
// module chunks = 7